import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import "./App.css";

import LandingPage from "./pages/LandingPage";
import ReservePage from "./pages/ReservePage";
import ThankYouPage from "./pages/ThankYouPage";
import InternalSubmissions from "./pages/InternalSubmissions";
import AntiSpamPolicy from "./pages/legal/AntiSpamPolicy";
import PrivacyPolicy from "./pages/legal/PrivacyPolicy";
import TermsOfService from "./pages/legal/TermsOfService";

import DashboardLayout from "./pages/dashboard/DashboardLayout";
import Overview from "./pages/dashboard/Overview";
import Pipeline from "./pages/dashboard/Pipeline";
import LeadDetail from "./pages/dashboard/LeadDetail";
import SlotQueue from "./pages/dashboard/SlotQueue";
import CalendarPage from "./pages/dashboard/CalendarPage";
import Campaigns from "./pages/dashboard/Campaigns";
import Reports from "./pages/dashboard/Reports";
import SettingsPage from "./pages/dashboard/SettingsPage";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/reserve" element={<ReservePage />} />
        <Route path="/thank-you" element={<ThankYouPage />} />
        <Route path="/internal/submissions" element={<InternalSubmissions />} />
        <Route path="/anti-spam-policy" element={<AntiSpamPolicy />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-of-service" element={<TermsOfService />} />

        <Route path="/demo" element={<DashboardLayout />}>
          <Route index element={<Overview />} />
          <Route path="pipeline" element={<Pipeline />} />
          <Route path="leads/:leadId" element={<LeadDetail />} />
          <Route path="slots" element={<SlotQueue />} />
          <Route path="calendar" element={<CalendarPage />} />
          <Route path="campaigns" element={<Campaigns />} />
          <Route path="reports" element={<Reports />} />
          <Route path="settings" element={<SettingsPage />} />
        </Route>
      </Routes>
      <Toaster position="top-right" richColors />
    </BrowserRouter>
  );
}

export default App;
